import _ from 'lodash'
import { createSelector } from 'reselect'

import { NurserySettingsFormBuilder } from 'services/nurseries/models'

import { transformObject } from 'services/nurseryContext/common/selectors'

import { RootState } from 'core/reducers'

import { FormBuilderField, FormBuilderGroup, FormBuilderSection, FormBuilderSubGroup } from '../models'

export const getFormBuilderSettingsAvailable = (state: RootState) => state.formBuilderSettings.available

export const getSettings = createSelector(
  [getFormBuilderSettingsAvailable],
  (state) => {
    if (!state?.data) {
      return null
    }

    const response = {
      ...state.data,
      fields: {
        child: state?.data?.child || {},
      },
    }
    delete response.child

    return transformObject(response)
  },
)

export const getAvailableFields = (
  formBuilderStructure: FormBuilderSection[],
  nurseryFormBuilderSettings: NurserySettingsFormBuilder,
): FormBuilderSection[] => (
  _.filter(_.map(formBuilderStructure, (section: FormBuilderSection) => {
    const groups = _.filter(_.map(section.groups, (group: FormBuilderGroup) => {
      const subGroups = _.filter(_.map(group.subGroups, (subGroup: FormBuilderSubGroup) => {
        const fields = _.filter(subGroup.fields, (field: FormBuilderField) => {
          if ('termsAndConditions' === field.key || 'agreement' === field.key) {
            return true
          }

          return (
            true === !!_.get(nurseryFormBuilderSettings, field.key)
          )
        })

        return fields.length ? { ...subGroup, fields } : null
      }))

      return subGroups.length ? { ...group, subGroups } : null
    }))

    return groups.length ? { ...section, groups } : null
  }))
)
